module.exports = __webpack_public_path__ + "img/home-bg6-1.cad5532a.png";